import { render, staticRenderFns } from "./ConfirmTreatmentModal.vue?vue&type=template&id=2fbb5f1c&scoped=true"
import script from "./ConfirmTreatmentModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmTreatmentModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmTreatmentModal.vue?vue&type=style&index=0&id=2fbb5f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb5f1c",
  null
  
)

export default component.exports